import { useState, useEffect } from 'react';
import { createSelector } from 'reselect';
import { useFunction } from '@laigu/store';

import { getSubSourceApi, addSubSourceApi, deleteSubSourceApi, updateSubSourceApi } from './api/index';

const toOptions = val => ({ label: String(val.display_name ?? ''), value: val.sub_source_name });
const toParams = val => ({ display_name: val.label, sub_source_name: val.value });
const getDataList = createSelector(
  [defaultWebSource => defaultWebSource, (defaultWebSource, source) => source],
  (defaultWebSource, source) => [
    { ...toOptions(defaultWebSource), disabled: true },
    ...source.map(val => toOptions(val))
  ]
);

const useSubSource = source => {
  const subFunc = useFunction('sub_source');
  const [subSourceList, setList] = useState([]);

  const addSubSource = displayName => {
    return addSubSourceApi(source, displayName).then(res => {
      if (res.data.sub_source) {
        const { sub_source_name, display_name } = res.data.sub_source;
        setList([...subSourceList, { sub_source_name, display_name }]);
      }
    });
  };

  const deleteSubSource = subSource => {
    return deleteSubSourceApi(source, subSource).then(() => {
      const list = [...subSourceList];
      const index = list.findIndex(s => s.sub_source_name === subSource.sub_source_name);
      list.splice(index, 1);
      setList(list);
    });
  };

  const updateSubSource = data => {
    return updateSubSourceApi(source, data).then(() => {
      const list = [...subSourceList];
      const item = list.find(i => i.sub_source_name === data.sub_source_name);
      if (item) {
        item.display_name = data.display_name;
      }
      setList(list);
    });
  };

  useEffect(() => {
    if (source !== 'web' || !subFunc) {
      return;
    }
    getSubSourceApi(source).then(res => {
      if (res.data && res.data.sub_sources) {
        setList(
          res.data.sub_sources.map(d => ({
            sub_source_name: d.sub_source_name,
            display_name: d.display_name
          }))
        );
      }
    });
  }, [source, subFunc]);

  return { subSourceList, addSubSource, deleteSubSource, updateSubSource, getDataList, toParams };
};

export default useSubSource;
